import { render, staticRenderFns } from "./ListManagements.vue?vue&type=template&id=5cb3bb80"
import script from "./ListManagements.vue?vue&type=script&lang=js"
export * from "./ListManagements.vue?vue&type=script&lang=js"
import style0 from "./ListManagements.vue?vue&type=style&index=0&id=5cb3bb80&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cb3bb80')) {
      api.createRecord('5cb3bb80', component.options)
    } else {
      api.reload('5cb3bb80', component.options)
    }
    module.hot.accept("./ListManagements.vue?vue&type=template&id=5cb3bb80", function () {
      api.rerender('5cb3bb80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Tickets/ListManagements.vue"
export default component.exports